@if (viewModel$ | async; as viewModel) {
  @if (viewModel.training) {
    <app-single-training-title-section [training]="viewModel.training" class="title-section"> </app-single-training-title-section>
    <div class="container">
      @if (viewModel.training.sessions?.length) {
        <h1 class="session-cards-header" translate>SINGLE_TRAINING.SESSION_OVERVIEW</h1>
        @for (session of viewModel.training.sessions; track session; let i = $index) {
          <app-training-session-card
            [session]="session"
            [index]="i"
            [sessionsCount]="viewModel.training.sessions.length"
            [sessionProgress]="progressOfSession(viewModel.sessionProgresses, session)"
            [expanded]="isExpanded(session.id, viewModel.sessionProgresses, viewModel.mostRecentSession, viewModel.scrollToId)"
            [locked]="!viewModel.training.isAccessible"
            (openInfoDialogEmitter)="openInfo()"
            [attr.most-recent]="isMostRecent(session.id, viewModel.mostRecentSession, viewModel.scrollToId)"
            #sessionPanels
            class="mb-4 mb-sm-5 session-card">
            @if (sessionsAvailable(viewModel.training)) {
              @for (slide of filterSlides(session.slides, viewModel.hideCertificate); track slide) {
                <app-slide-summary
                  [link]="getSlideLink(viewModel.training, session, slide)"
                  [disabled]="!isSlideAvailable(slide, viewModel.nextAvailableSlide, viewModel.visitedSlides, viewModel.trainingRated, viewModel.certificateAvailable)"
                  [title]="titleForSlide(slide)"
                  [duration]="getFormattedDurationForSlide(slide)"
                  [icon]="iconForSlide(slide)"
                  [visited]="isSlideVisited(slide, viewModel.visitedSlides, viewModel.trainingRated)"
                  class="px-3 px-sm-0">
                </app-slide-summary>
              }
            }
          </app-training-session-card>
        }
      }
      @if (!viewModel.training.sessions?.length) {
        <app-training-coming-soon [title]="viewModel.training.name"> </app-training-coming-soon>
      }
      @if (trainersAvailable(viewModel.training)) {
        @if (viewModel.otherTrainingsFromTrainer) {
          @if (!moreThanSingleTrainer(viewModel.training)) {
            <!-- If there is only one trainer: print correctly gendered headline -->
            @switch (viewModel.training.trainers[0].gender) {
              @case ('m') {
                <h1 class="trainer-header" translate>SINGLE_TRAINING.ABOUT_TRAINER_SINGULAR.MALE</h1>
              }
              @case ('f') {
                <h1 class="trainer-header" translate>SINGLE_TRAINING.ABOUT_TRAINER_SINGULAR.FEMALE</h1>
              }
              <!-- In unspecified case (wanted, wrong data, ...), print a generic headline -->
              @default {
                <h1 class="trainer-header" translate>SINGLE_TRAINING.ABOUT_TRAINER_SINGULAR.UNDEFINED</h1>
              }
            }
          }
          <!-- If there are more trainers, use this headline -->
          @if (moreThanSingleTrainer(viewModel.training)) {
            <h1 class="trainer-header" translate>SINGLE_TRAINING.ABOUT_TRAINER_PLURAL</h1>
          }
          @for (trainer of viewModel.training?.trainers; track trainer) {
            <app-trainer-card
              [trainer]="trainer"
              [otherTrainings]="viewModel.otherTrainingsFromTrainer[trainer.id]"
              class="mb-5">
            </app-trainer-card>
          }
        }
      }
    </div>
  }
}
